import styled from "styled-components";
import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import { JackpotThemeType } from "../../../../../../services/jackpots-with-state/jackpots-with-state.service.interface";
import {JACKPOT_WIDGET_LAYOUT} from "../../../../jackpot-widget.component";

interface IJackpotWidgetCollectingLabelBox {
    layout: JACKPOT_WIDGET_LAYOUT;
    widgetWidth: number;
    themeType: JackpotThemeType;
}

const handleCollectingLabelFontSize = (layout: JACKPOT_WIDGET_LAYOUT, widgetWidth: number) => {
    switch (layout) {
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE:
            return widgetWidth * 16 / 468 + "px";
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE:
            return widgetWidth * 10 / 375 + "px";
        case JACKPOT_WIDGET_LAYOUT.PORTRAIT:
        default:
            return widgetWidth * 10 / 131 + "px";
    }
};

const JackpotWidgetCollectingLabelDefaultBox = styled.div<IJackpotWidgetCollectingLabelBox>`
    ${({theme}) => theme.font.presets.body};
    color: ${({theme}) => theme.colors.brandSecondary};
    letter-spacing: 0.02rem;

    width: ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE ? "62%" : "100%" };
    text-align: ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE ? "left" : "center" };
    font-size: ${({widgetWidth, layout}) => handleCollectingLabelFontSize(layout, widgetWidth)};
`;

const JackpotWidgetCollectingLabelCasino777Box = styled(JackpotWidgetCollectingLabelDefaultBox)`
    color: ${({theme, themeType}) => themeType === JackpotThemeType.Light ? theme.colors.danger : theme.colors.brandSecondary};
`;

export const JackpotWidgetCollectingLabelBox = styledByTheme(JackpotWidgetCollectingLabelDefaultBox)
    .forCasino777(JackpotWidgetCollectingLabelCasino777Box).apply();
